<template>
    <div v-if="wrapper" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <transition
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100"
                leave-to-class="opacity-0">
                <div v-show="show" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-purple opacity-75"></div>
                </div>
            </transition>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;

            <transition
                enter-active-class="ease-out duration-300"
                enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100 translate-y-0 sm:scale-100"
                leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <div v-show="show" class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div>
                        <div>
                            <h3 class="text-lg font-bold leading-6 font-medium text-gray-900" id="modal-headline">
                                Confirm
                            </h3>
                            <div class="mt-2">
                                <p class="leading-5 text-gray-500" v-html="confirmMessage">
                                    <!-- The confirmMessage will be rendered here -->
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 flex">
                        <span class="flex w-full rounded-md pr-1">
                            <button id="confirm-confirm" @click="$emit('confirmed')" type="button" class="inline-flex justify-center font-bold w-full rounded-md border border-primary px-4 py-2 bg-white text-primary leading-6 font-medium shadow-sm focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                Confirm
                            </button>
                        </span>
                        <span class="flex w-full rounded-md pl-1">
                            <button @click="$emit('close')" type="button" class="inline-flex justify-center font-semibold w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-primary-300 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                Cancel
                            </button>
                        </span>
                    </div>
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['account', 'open', 'accountNumber', 'confirmMessage'],

        watch: {
            open(open, oldOpen) {
                if (open && ! oldOpen) {
                    this.openModal();
                } else if (! open && oldOpen) {
                    this.closeModal();
                }
            }
        },

        mounted() {
            // SetDeposit remounts this tree via :key="renderKey" after income loads.
            // If open was already true across that remount, the watcher never fires
            // (no false→true transition) and the dialog would stay closed forever.
            if (this.open) {
                this.openModal();
            }
        },

        data() {
            return {
                wrapper: false,
                show: false
            }
        },

        methods: {
            openModal() {
                this.wrapper = true;

                setTimeout(() => {
                    this.show = true;
                }, 100);
            },

            closeModal() {
                this.show = false;

                setTimeout(() => {
                    this.wrapper = false;
                }, 500);
            },
        },
    }
</script>